import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-help',
  templateUrl: './edit-help.component.html',
  styleUrls: ['./edit-help.component.scss']
})
export class EditHelpComponent implements OnInit {

  comment:any;
  constructor(
    public dialogRef: MatDialogRef<EditHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.comment = this.data.comment;
  }

  updateComment() {
    this.dialogRef.close(this.data);
  }

}
